import { useEffect, useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'

/**
 * Hook, that returns the current dimensions of an HTML element.
 * Doesn't play well with SVG.
 */

const useResizeObserver = (ref: any) => {
  const [dimensions, setDimensions] = useState<any>(null)

  useEffect(() => {
    if (!ref || !ref.current) return

    const observeTarget = ref.current
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setDimensions(entry.contentRect)
      })
    })

    resizeObserver.observe(observeTarget)

    return () => {
      resizeObserver.unobserve(observeTarget)
    }
  }, [ref])

  return dimensions
}

export default useResizeObserver
